import styled from "styled-components";

const bp = {
  md: "900px",
  sm: "560px",
};

const c = {
  black: "#151515",

  white: "rgba(255,255,255,0.92)",
  white2: "rgba(255,255,255,0.72)",
  white3: "rgba(255,255,255,0.60)",

  gold: "#c9a227",
  gold2: "rgba(201,162,39,0.35)",

  pink: "#fc9ac4",
  pinkSoft: "rgba(252,154,196,0.22)",
  pinkSoft2: "rgba(252,154,196,0.14)",

  line: "rgba(255,255,255,0.10)",
};

export const FooterWrap = styled.footer`
  background: ${c.black};
  border-top: 1px solid rgba(201, 162, 39, 0.4);
`;

export const Inner = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  padding: 34px 18px 18px;
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(160px, 1fr));
  gap: 18px;

  @media (max-width: ${bp.md}) {
    grid-template-columns: repeat(2, minmax(160px, 1fr));
  }

  @media (max-width: ${bp.sm}) {
    grid-template-columns: 1fr;
  }
`;

/* ✅ TOATE COLOANELE LA FEL */
export const Col = styled.div`
  padding: 12px 8px;
`;

export const ColTitle = styled.h4`
  margin: 0 0 12px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #ffffff;
  position: relative;
  padding-left: 18px;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 6px;
    width: 8px;
    height: 8px;
    background: ${c.gold};
    transform: rotate(45deg);
    box-shadow: 0 0 8px ${c.pinkSoft}; /* ✅ glow roz subtil */
  }
`;

export const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
`;

/* ✅ Link standard */
export const FLink = styled.a`
  color: ${c.white2};
  text-decoration: none;
  font-size: 14px;
  line-height: 1.35;

  display: inline-flex;
  align-items: center;
  gap: 10px;

  transition:
    color 180ms ease,
    transform 180ms ease;

  &:hover {
    color: ${c.pink};
    transform: translateX(2px);
  }

  &:focus-visible {
    outline: 2px solid ${c.pinkSoft};
    outline-offset: 3px;
    border-radius: 10px;
  }
`;

/* ✅ text simplu (pentru Date comerciale) */
export const TextLine = styled.div`
  color: ${c.white2};
  font-size: 14px;
  line-height: 1.35;

  strong {
    color: ${c.white};
    font-weight: 800;
    letter-spacing: 0.2px;
  }
`;

/* ✅ mini icon pentru contact/social */
export const MiniIcon = styled.span`
  width: 18px;
  height: 18px;
  display: inline-grid;
  place-items: center;

  color: ${c.gold};
  font-size: 16px;
  transition: color 180ms ease;

  ${FLink}:hover & {
    color: ${c.pink};
  }
`;

/* ✅ plăți în aceeași listă/coloană */
export const PaymentsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const PaymentImg = styled.img`
  height: 26px;
  width: auto;
  display: block;

  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid ${c.line};
  background: rgba(0, 0, 0, 0.25);

  transition: border-color 180ms ease;

  &:hover {
    border-color: ${c.pinkSoft2};
  }
`;

export const Divider = styled.div`
  margin: 18px 0 14px;
  height: 1px;
  background: rgba(201, 162, 39, 0.28);
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  color: ${c.white3};
  font-size: 13px;

  strong {
    color: ${c.white};
    font-weight: 700;
  }

  padding: 6px 0;
`;

export const PaymentsCenter = styled.div`
  margin-top: 28px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 60px; /* 🔥 mai mare */
    width: auto;
    border-radius: 100px;
    opacity: 0.95;
    transition:
      transform 200ms ease,
      opacity 200ms ease;

    &:hover {
      transform: scale(1.05);
      opacity: 1;
    }
  }
`;
